// extracted by mini-css-extract-plugin
module.exports = {"cta":"styles_cta__2DiaX","content":"styles_content__10uGl","btn":"styles_btn__ReZXq"};